
export default function (state={}, action) {

	switch (action.type) {

	case 'FETCH_QUESTION_REQUEST':
		state[action.questionId]=true
		return state


	case 'LOGOUT':
		return {}

	default:
		return state

	}
}